export const IcInfo = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      className={className}
    >
      <path
        d="M8.13574 0.289062C12.0938 0.289062 15.3027 3.49801 15.3027 7.45605C15.3027 11.4141 12.0938 14.623 8.13574 14.623C4.1777 14.623 0.96875 11.4141 0.96875 7.45605C0.96875 3.49801 4.1777 0.289063 8.13574 0.289062ZM7.46875 6.78906C7.10072 6.78924 6.80275 7.08798 6.80273 7.45605C6.80273 7.82414 7.10071 8.12287 7.46875 8.12305V10.7891C7.46875 11.1573 7.76755 11.4561 8.13574 11.4561C8.50393 11.4561 8.80273 11.1573 8.80273 10.7891V8.09668C8.80282 7.96343 8.80252 7.80441 8.78418 7.66797C8.76202 7.50329 8.70302 7.27528 8.50977 7.08203C8.31651 6.88878 8.08851 6.82978 7.92383 6.80762C7.78739 6.78927 7.62837 6.78898 7.49512 6.78906C7.48632 6.78907 7.47731 6.78906 7.46875 6.78906ZM8.13281 4.12305C7.76638 4.12305 7.46892 4.42102 7.46875 4.78906C7.46875 5.15725 7.76627 5.45605 8.13281 5.45605H8.13867C8.50521 5.45605 8.80273 5.15725 8.80273 4.78906C8.80256 4.42102 8.5051 4.12305 8.13867 4.12305H8.13281Z"
        fill="#047819"
      />
    </svg>
  )
}
